import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services API
export const getServices = async () => {
  const response = await axios.get(`${API}/services`);
  return response.data;
};

export const getAvailability = async (date) => {
  const response = await axios.get(`${API}/availability/${date}`);
  return response.data;
};

// Bookings API
export const createBooking = async (bookingData) => {
  const response = await axios.post(`${API}/bookings/create`, bookingData);
  return response.data;
};

export const getBooking = async (bookingId) => {
  const response = await axios.get(`${API}/bookings/${bookingId}`);
  return response.data;
};

// Payments API
export const createCheckoutSession = async (bookingId, hostUrl) => {
  const response = await axios.post(`${API}/payments/create-checkout`, {
    bookingId,
    hostUrl
  });
  return response.data;
};

export const getPaymentStatus = async (sessionId) => {
  const response = await axios.get(`${API}/payments/status/${sessionId}`);
  return response.data;
};
